import * as React from 'react'
import styled from 'styled-components'

const Base = styled.span`
  display: inline-block;
  vertical-align: middle;
  height: 1.5em;
  width: 2.5em;
  position: relative;
  border-radius: 0.75em;
  ::before {
    display: block;
    content: '';
    border-radius: inherit;
    background-color: var(--color-fg);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.25;
    transition: background-color 400ms;
  }
  input:checked + &::before {
    background-color: var(--color-primary);
    opacity: 1;
    transition: all 400ms;
  }
`

const Switch = styled.span`
  position: absolute;
  display: block;
  width: 1.5em;
  height: 1.5em;
  top: 0;
  left: 0;
  border-radius: inherit;
  padding: 0.125em;
  input:checked + ${Base} > & {
    left: 1em;
    transition: all 400ms;
  }
  ::before {
    display: block;
    content: '';
    border-radius: inherit;
    background-color: var(--color-bg-light);
    box-shadow: var(--box-shadow-medium);
    width: 100%;
    height: 100%;
    transition: all 400ms;
  }
`

const HiddenInput = styled.input`
  display: none;
`

const ToggleSwitch = ({ value, onChange }) => {
  return (
    <label>
      <HiddenInput
        type="checkbox"
        name="visible"
        checked={value}
        // onClick={() => {
        //   setValue(!value)
        // }}
        onChange={onChange}
      />
      <Base>
        <Switch />
      </Base>
    </label>
  )
}

export default ToggleSwitch
